import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Candidate|Exam|Comments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateExamComments';
export type SPCandidateExamCommentsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelSource`
	| `${LocNameStart}LabelSubject`
	| `${LocNameStart}LabelText`;

export const spCandidateExamCommentsLocs: LocDefs<SPCandidateExamCommentsLocNames> = {
	SPCandidateExamCommentsTitlePage: {
		defaultValue: 'Comments',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamComments.Title.ExamComments',
		...sharedProperties,
	},
	SPCandidateExamCommentsTitleTab: {
		defaultValue: 'Comments',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamComments.Title.Tab',
		...sharedProperties,
	},
	SPCandidateExamCommentsLabelSource: {
		defaultValue: 'Source (Context/Score)',
		description: 'Column heading for: Source (Context/Score)',
		displayPath: `${pathStart}Source (Context/Score)`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamComments.ColumnHeading.Source',
		...sharedProperties,
	},
	SPCandidateExamCommentsLabelSubject: {
		defaultValue: 'Subject (Name/ID)',
		description: 'Column heading for: Subject (Name/ID)',
		displayPath: `${pathStart}Subject (Name/ID)`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamComments.ColumnHeading.Subject',
		...sharedProperties,
	},
	SPCandidateExamCommentsLabelText: {
		defaultValue: 'Text',
		description: 'Column heading for: Text',
		displayPath: `${pathStart}Text`,
		displayType: 'Label',
		legacyName: 'Exam/CandidateExamComments.ColumnHeading.Text',
		...sharedProperties,
	},
};

export type SPCandidateExamCommentsLocType = LocMap<SPCandidateExamCommentsLocNames>;
